module.exports = __webpack_public_path__ + "img/empty-image-error.92334a75.svg";